import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-xhr-backend"

export const ALLOWED_LANGUAGES = [
  "en",
  "es",
  "es_US",
  "es_MX",
  "es_ES",
  "fr",
  "fr_CA",
  "de",
  "pt"
]

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false
    },
    supportedLngs: ALLOWED_LANGUAGES,
    ns: ["common"],
    defaultNS: "common",
    fallbackNS: "common",
    fallbackLng: "en",
    debug: false,
    keySeparator: false,
    nsSeparator: false,
    returnNull: false,
    returnEmptyString: false,
    lng:
      localStorage.getItem("i18nLocalStorageKey") || navigator.language || "en",
    backend: {
      loadPath: `/translations/{{lng}}.json?${Date.now()}`
    },

    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain"
      ],

      // keys or params to lookup language from
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupLocalStorage: "i18nextLng",
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,

      // cache user language on
      caches: ["localStorage", "cookie"],
      excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

      // optional expire and domain for set cookie
      cookieMinutes: 10,
      cookieDomain: "bnewt",

      // optional htmlTag with lang attribute, the default is:
      htmlTag: document.documentElement
    },

    interpolation: {
      escapeValue: false // React should already be escaping strings
    }
  })
export default i18n
